<template>
  <div class="cpt-bottom">
    <div
      :class='selected==="index" ? "is-selected" : ""'
      @click="gotoRouter('index')"
      class="bottom-item">
      <img src="@/assets/images/yuyue-d@1x.png" v-show="selected!=='index'">
      <img src="@/assets/images/yuyue-s@1x.png" v-show="selected==='index'">
      <span>预约</span>
    </div>
    <div
      :class='selected==="mine" ? "is-selected" : ""'
      @click="gotoRouter('mine')"
      class="bottom-item">
      <img src="@/assets/images/wod-d@1x.png" v-show="selected!=='mine'">
      <img src="@/assets/images/wod-s@1x.png" v-show="selected==='mine'">
      <span>我的</span>
    </div>
  </div>
</template>

<script type="text/javascript">
export default{
  data () {
    return {
      selected: ''
    }
  },
  methods: {
    gotoRouter (name) {
      this.selected = name
      this.$router.push({
        name: this.selected
      })
    }
  },
  mounted () {
    this.selected = this.$route.name
  }
}
</script>

<style type="text/css" lang="scss" scoped>
.cpt-bottom{
  width: 100%;
  height: .49rem;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  flex-shrink: 0;
  box-shadow: 0 0 4px 0 rgba(120,120,120,0.50);
  background: #FFF;
  .bottom-item{
    flex: 1;
    font-size: .1rem;
    color: #666666;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .is-selected{
    color: #306FFF;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Bottom.vue